import { types } from "../types/types";

const initialState = {
  cargada: false,
  items: [],
  loading: false,
  error: null,
};

export const aportesAfiliadoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.aportesTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.aportesTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.aportesTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        cargada: false,
      };
    case types.aportesLimpiar:
      return {
        loading: false,
        items: [],
        cargada: false,
      };
    case 'actualizarAportes':
      let array = [];
      if (action.payload.length !== 0) {
        for (let item1 of state.items) {
          for (let item2 of action.payload) {
            if (item1.cuit !== item2.empresa.cuit) {
              array.push(item1)
            }
          }
        }
      } else {
        array = state.items
      }
      return {
        ...state,
        items: array
      };
    default:
      return state;
  }
};
